import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import * as serviceWorker from './serviceWorker';

// import coreui style
// import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/scss/style.scss';
import { icons } from './Assets/icons';

import './index.scss';

// Polyfill for process.env (required for @coreui/icons-react)
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: {} };
}

React.icons = icons;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();